export const LocationAdExtension = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'LocationAdExtension',
    },
  },
};
